export class ReturnPopupItem {
    product;
    batch;
    serialNumber;
    document;

    /**
     * Creates a prompt message object for use by Prompt.
     * @function
     * @memberof ReturnPopup
     * @param {product} product Return popup product.
     * @param {string} batch Return popup batch.
     * @param {string} serialNumber Return popup serialNumber.
     * @param {document} document Return popup document.
     */
    constructor(product, batch, serialNumber, document) {
        this.product = product;
        this.batch = batch;
        this.serialNumber = serialNumber;
        this.document = document;
    }
}

export class ReturnPopup {
    returnPopup;

    /**
     * Creates a prompt object for use by bo-confirmation.
     * @function
     * @param {product} product Return popup product.
     * @param {string} batch Return popup batch.
     * @param {string} serialNumber Return popup serialNumber.
     * @param {document} document Return popup document.
     */

    constructor(title, body, confirmText, type) {
        this.returnPopup = new ReturnPopupItem(title, body, confirmText, type);
    }
}
